import { render, staticRenderFns } from "./CmgGuacModeBadge.vue?vue&type=template&id=05227525&scoped=true&lang=pug"
import script from "./cmg-guac-mode-badge.ts?vue&type=script&lang=ts&external"
export * from "./cmg-guac-mode-badge.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGuacModeBadge.vue?vue&type=style&index=0&id=05227525&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05227525",
  null
  
)

export default component.exports